import { FieldError } from "components/common/FieldError";
import { Checker, CheckerBox, Indicator } from "components/common/Mark";
import { PASSWORD_STRENGTH } from "constants/auth";
import { useState } from "react";
import styled from "styled-components";
import zxcvbn from "zxcvbn";
import { IS_DEV, IS_PROD } from "config/env";
import { PasswordInput } from "components/common/PasswordInput";

const Body = styled.div`
  // background: red;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const Title = styled.div`
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 30px;
  font-weight: 500;
  color: #464646;
  margin-top: 10px;
  text-align: center;
`;

const ContainerDescription = styled.div`
  // background: lightgray;
  width: 280px;
  font-size: 14px;
  color: #7676b6;
  margin-top: 10px;
  margin-bottom: 5px;
`;

const AccountContainer = styled.div`
  background: Aliceblue;
  border-radius: 6px;
  width: 280px;
  padding: 10px 20px;
  white-space: preline;
`;

const SingleUsername = styled.div`
  // background: red;
  text-align: center;
  font-size: 18px;
`;

const PasswordContainer = styled.div`
  // background: lavender;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 20px;
  // border: solid PaleTurquoise 2px;
  border: solid lavender 2px;
  width: 320px;
  margin-top: 10px;
`;

const StyledForm = styled.form`
  width: 280px;
  padding: 15px 0;
  // background: red;
`;

const ResetPasswordInput = styled(PasswordInput)`
  width: 98.5%;
`;

const PasswordBox = styled.div`
`;

const Topic = styled.label`
  // background: lightpink;
  display: inline-block;
  margin-top: 8px;
  color: ${props => props.$disabled ? 'gray' : 'blue'};
  font-size: 15px;
`;

const ButtonContainer = styled.div`
// background: red;
  width: 98.5%;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

const StyledPasswordSubmit = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border: none;
  background: pink;
  // margin-bottom: 20px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  font-weight: 700;
  color: #363636;
  cursor: pointer;
`;

const StatusBar = styled.div`
// background: pink;
  box-sizing: border-box;  
  width: 280px;
  padding-top: 12px;
  padding-bottom: 10px;
  padding-left: 5px;
  // padding-right: 5px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`;

const StatusTextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

export const ResetPasswordForm = ({
  username,
  onPasswordSubmit,
  onBack,
  onClose,
}) => {
  const [fieldError, setFieldError] = useState({});
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  
  const passwordScore = zxcvbn(password).score;
  const passwordStrength = PASSWORD_STRENGTH[passwordScore];
  const passwordState = {
    length: password.length >= 8,
    alpha: /[A-Za-z]/.test(password),
    digit: /[0-9]/.test(password),
    special: /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/.test(password),
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setFieldError({});
  };

  const handlePassword2Change = (e) => {
    setPassword2(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    
    const errors = {};

    if (!password) {
      errors.password = '필수 항목입니다.';
    } else {
      const validNewPassword = Object.values(passwordState).every(Boolean);
      if (!validNewPassword) {
        errors.password = '비밀번호 조건을 확인해 주세요.';
      }
    }
    
    if (!password2) {
      errors.password2 = '필수 항목입니다.';

    } else if (password !== password2) {
      errors.password2 = '비밀번호가 일치하지 않습니다.';
    }

    if (IS_PROD && Object.keys(errors).length > 0) {
      setFieldError(errors);
      return;
    }
    
    onPasswordSubmit(password, password2);
  };

  return (
    <>
      <Body>
        <Title>비밀번호변경</Title>
        
        <ContainerDescription>계정</ContainerDescription>
        <AccountContainer>
          <SingleUsername>{username}</SingleUsername>
        </AccountContainer>
        
        <PasswordContainer>
          <StyledForm onSubmit={handleSubmit}>
            <PasswordBox>
              <Topic >새 비밀번호</Topic>
              {password.length > 0 && (
                <Indicator score={passwordScore}>강도: {passwordStrength}</Indicator>
              )}
              <ResetPasswordInput name="password" value={password} onChange={handlePasswordChange} />
              {password.length > 0 && (
                <div>
                  <CheckerBox>
                    조건
                    <Checker ok={passwordState.length}>8자이상</Checker>
                    <Checker ok={passwordState.alpha}>영문포함</Checker>
                    <Checker ok={passwordState.digit}>숫자포함</Checker>
                    <Checker ok={passwordState.special}>특수문자포함</Checker>
                  </CheckerBox>
                </div>
              )}
              <FieldError message={fieldError.password} />
              
              <Topic>새 비밀번호 확인</Topic>
              <ResetPasswordInput name="password2" value={password2} onChange={handlePassword2Change} />              
              <FieldError message={fieldError.password2} />
            </PasswordBox>
            <ButtonContainer>
              <StyledPasswordSubmit type="submit" value="비밀번호수정" />
            </ButtonContainer>
          </StyledForm>         
        </PasswordContainer>
      </Body>
    
      <StatusBar>
          <StatusTextButton onClick={onClose}>로그인</StatusTextButton>
          <StatusTextButton onClick={onBack}>뒤로</StatusTextButton>
      </StatusBar>
    </>
  );
};